import React, { useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Скрытый жест обслуживания: три быстрых нажатия по логотипу перезагружают
// страницу. Нужен, когда киоск «залип» (не отрисовался экран, потерялось
// соединение), а до Electron-пульта или клавиатуры не добраться — пользователь
// об этом не знает, кнопки на экране нет. Одиночное/двойное нажатие ничего
// не делает, поэтому случайно не сработает.
const TAPS_TO_RELOAD = 3;
const TAP_WINDOW_MS = 800;

function Header() {
    const { i18n } = useTranslation();
    const tapCountRef = useRef(0);
    const tapTimerRef = useRef(null);

    useEffect(() => () => clearTimeout(tapTimerRef.current), []);

    const handleLogoTap = () => {
        clearTimeout(tapTimerRef.current);
        tapCountRef.current += 1;

        if (tapCountRef.current >= TAPS_TO_RELOAD) {
            tapCountRef.current = 0;
            window.location.reload();
            return;
        }

        // Серия прервалась — начинаем счёт заново, иначе три случайных
        // нажатия за весь сеанс тоже сработали бы как жест.
        tapTimerRef.current = setTimeout(() => {
            tapCountRef.current = 0;
        }, TAP_WINDOW_MS);
    };

    const changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    };

    return (
        <header className="h-[6vh] bg-[#EDEFF4] flex items-center justify-between pl-[2.4vw] pr-[2.4vw]">
            <div
                onClick={handleLogoTap}
                className="text-[#1E2321] text-[3vh] font-sans font-extrabold select-none"
            >
                Print<span className="text-[#246CE2]">Box</span>
            </div>
            <div className="flex bg-white rounded-full shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] p-[0.4vh]">
                <button
                    onClick={() => changeLanguage("kk")}
                    className={`px-[2.2vw] py-[0.7vh] rounded-full text-[1.5vh] font-sans font-bold transition-colors duration-300 ${
                        i18n.language === "kk"
                            ? "bg-[#12161F] text-white"
                            : "text-[#7B8290]"
                    }`}
                >
                    KZ
                </button>
                <button
                    onClick={() => changeLanguage("ru")}
                    className={`px-[2.2vw] py-[0.7vh] rounded-full text-[1.5vh] font-sans font-bold transition-colors duration-300 ${
                        i18n.language === "ru"
                            ? "bg-[#12161F] text-white"
                            : "text-[#7B8290]"
                    }`}
                >
                    RU
                </button>
                <button
                    onClick={() => changeLanguage("en")}
                    className={`px-[2.2vw] py-[0.7vh] rounded-full text-[1.5vh] font-sans font-bold transition-colors duration-300 ${
                        i18n.language === "en"
                            ? "bg-[#12161F] text-white"
                            : "text-[#7B8290]"
                    }`}
                >
                    EN
                </button>
            </div>
        </header>
    );
}

export default Header;
